import _ from "lodash";
import React, { useEffect, useState, useRef } from "react";
import { useRouteMatch } from "react-router-dom";

import { connect } from "react-redux";
import { Alert } from "reactstrap";

import IntlMessages from "util/intlMessages";
import { PageTitle, TTSModelSelector } from "components/standart";
import { LoadingIcon, setOnChange } from "components/special";
import { FloatCurrencies } from "components/special/payments";
import { adminAPI } from "redux/api";

import { apiUrls } from "./init";
import { FloatUsers } from "components/special/users";
const { api } = adminAPI.actions;

const PaymentsSettings = (props) => {
  const { url } = useRouteMatch();
  const { breadCrumbs } = props;
  const [settings, setSettings] = useState({});
  useEffect(() => {
    props.getSettings(
      {},
      {
        onRequest() {
          setSettings({});
          setDataSaved(false);
        },
        onSuccess(body) {
          setSettings(body);
        },
      }
    );
  }, []);

  breadCrumbs.push({
    title: <IntlMessages id="Payments.Settings" />,
    url,
  });

  const [dataSaved, setDataSaved] = useState(false);

  const successAlertRef = useRef(null);

  const changeSettings = setOnChange(settings, setSettings);

  // аттрибуты, которые необходимо отобразить
  const inputAttrs = ["textToSpeechCost", "textToSpeechCharsAmount"];

  const saveSettingsHandler = () => {
    // ограничим список отправляемых данных, пропустив данные о лендинге
    props.saveSettings(
      {
        body: { ...settings },
      },
      {
        onSuccess(body) {
          setSettings(body);
          setDataSaved(true);
          successAlertRef.current.scrollIntoView();
        },
      }
    );
  };

  return (
    <>
      <PageTitle {...breadCrumbs} />

      {settings._id ? (
        <div className="row">
          <div className="col-12 -col-lg-6">
            <div className="roe-card-style">
              <div className="roe-card-header"></div>
              <div className="roe-card-body">
                <div ref={successAlertRef}>
                  <Alert
                    className="alert-success"
                    isOpen={dataSaved}
                    toggle={() => setDataSaved(false)}
                  >
                    <IntlMessages id="saved" />
                  </Alert>
                </div>

                {inputAttrs.map((name, index) => {
                  return (
                    <div className="form-group row" key={index}>
                      <label className="col-4 col-form-label">
                        <IntlMessages id={`Payments.Settings.${name}`} />
                      </label>
                      <div className="col-8">
                        <input
                          type="number"
                          name={name}
                          value={+settings[name] || ""}
                          onChange={changeSettings}
                          className="form-control react-form-input"
                          autoComplete="off"
                          required
                        />
                      </div>
                    </div>
                  );
                })}

                <div className="form-group row">
                  <label className="col-4 col-form-label">
                    <IntlMessages id={`Payments.Settings.textToSpeechCurrencyId`} />
                  </label>
                  <div className="col-8">
                    <FloatCurrencies
                      _id={settings.textToSpeechCurrencyId}
                      showTitle={true}
                      showCount={false}
                      multi={false}
                      successHandler={([textToSpeechCurrencyId = null]) => {
                        setSettings({ ...settings, textToSpeechCurrencyId });
                      }}
                    />
                  </div>
                </div>

                <div className="form-group row">
                  <label className="col-4 col-form-label">
                    <IntlMessages id={`Payments.Settings.defaultAccountAdminId`} />
                  </label>
                  <div className="col-8">
                    <FloatUsers
                      _id={settings.defaultAccountAdminId}
                      showTitle={true}
                      showCount={false}
                      multi={false}
                      title={(value) => `${value.ident} ${value.profile.name}`}
                      successHandler={([defaultAccountAdminId = null]) => {
                        setSettings({ ...settings, defaultAccountAdminId });
                      }}
                    />
                  </div>
                </div>

                {/* 

                <div className="form-group row">
                  <label className="col-4 col-form-label">
                    <IntlMessages id={`Payments.Settings.textToSpeechModel`} />
                  </label>
                  <div className="col-8">
                    <TTSModelSelector
                      name="textToSpeechModel"
                      value={settings.textToSpeechModel}
                      setValue={(data) => setSettings({ ...settings, ...data })}
                    />
                  </div>
                </div>
                <div className="form-group row">
                      <label className="col-4 col-form-label">
                        <IntlMessages id={`Payments.Settings.textSpeed`} />
                      </label>
                      <div className="col-8">
                        <input
                          type="number"
                          name={"textSpeed"}
                          value={+settings.textSpeed || ""}
                          onChange={changeSettings}
                          className="form-control react-form-input"
                          autoComplete="off"
                        />
                      </div>
                    </div>
                     */}

                <div className="form-group row">
                  <div className="col-6">
                    <button
                      type="button"
                      className="form-control c-primary"
                      onClick={saveSettingsHandler}
                    >
                      <IntlMessages id="save" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <LoadingIcon />
      )}
    </>
  );
};

export default connect(null, {
  getSettings: api.get(apiUrls.settings),
  saveSettings: api.patch(apiUrls.settings),
})(PaymentsSettings);
